import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { Command } from 'cmdk'
import { Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { CurrencyCommandList } from '@/components/currency/CurrencyList'
import { Sheet } from '@/components/ui/Sheet'
import { useConverter } from '@/store/converter'
import { useUi } from '@/store/ui'

/** Global search (Ctrl/⌘+K): pick a currency to open it in the converter. */
export function SearchDialog() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const open = useUi((s) => s.searchOpen)
  const setOpen = useUi((s) => s.setSearchOpen)
  const setFrom = useConverter((s) => s.setFrom)
  const [query, setQuery] = useState('')

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setOpen(!useUi.getState().searchOpen)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [setOpen])

  const close = (o: boolean) => {
    setOpen(o)
    if (!o) setQuery('')
  }

  return (
    <Sheet open={open} onOpenChange={close} title={t('nav.search')}>
      <Command loop className="flex min-h-0 flex-1 flex-col">
        <div className="px-4 pb-2">
          <label className="flex h-12 items-center gap-2.5 rounded-xl border border-line-strong bg-surface-2 px-3.5 focus-within:border-gold-400/60">
            <Search className="size-4 text-subtle" aria-hidden />
            <Command.Input
              value={query}
              onValueChange={setQuery}
              placeholder={t('converter.search')}
              className="h-full flex-1 bg-transparent text-sm outline-none placeholder:text-subtle"
            />
          </label>
        </div>
        <Command.List className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 pb-4">
          <CurrencyCommandList
            query={query}
            onSelect={(code) => {
              setFrom(code)
              close(false)
              navigate('/convert')
            }}
          />
        </Command.List>
      </Command>
    </Sheet>
  )
}
